import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useToken } from '../components/items/UseToken';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProcessTable from '../components/RobotsPageComponents/ProcessTable';
import MachinesTable from '../components/RobotsPageComponents/MachinesTable';
import NewWizardContainer from '../components/RobotsPageComponents/NewWizardContainer';
import MachineWizardStepper from '../components/RobotsPageComponents/MachineWizardStepper';
import GenericDataTable from '../components/Common/GenericDataTable';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import AgentWizardStepper from '../components/RobotsPageComponents/AgentWizardStepper';
import ActionsMenu from '../components/Common/ActionsMenu';
import ConfirmationDialog from '../components/Common/ConfirmationDialog';
import DeployWidgetModal from '../components/RobotsPageComponents/DeployWidgetModal';
import { AgentsEmptyStateInfo } from '../components/EmptyStates'
import { AgentsReadyState } from '../components/ReadyStates'

export default function Agents({ initialTab }) {

const { token } = useToken()
const navigate = useNavigate();


    const [tabValue, setTabValue] = useState(initialTab);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [selectedGuid, setSelectedGuid] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const location = useLocation();


    useEffect(() => {
    }, [confirmationOpen])

const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
    };


    const handleOptionSelect = (option, guid) => {
        if (option.value === "edit") {
            editAgent(guid);
        }
        else if (option.value === "delete") {
            setSelectedGuid(guid);
            setConfirmationOpen(true);
        }
        else if (option.value === "deploy_widget") {
            setSelectedGuid(guid);

            handleDeployWidget(guid)
        }
        else if (option.value === "set_default_widget") {
            handleSetDefaultWidget(guid)
        }

        
        
    };

    const options = [
        { label: 'Edit', value: 'edit' },
        { label: 'Delete', value: 'delete' },
        { label: 'Deploy Widget', value: 'deploy_widget' },
        { label: 'Set as Home Widget', value: 'set_default_widget' },

    ];

    const editAgent = (guid) => {

        navigate(`/agents/${guid}`); 
        console.log('Wybrana opcja: ' + guid);
    };
    const handleDelete = async () => {
        setConfirmationOpen(false);

        try {
            const response = await fetch("api/deleteagent", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                },
                body: JSON.stringify({ guid:selectedGuid }),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            console.log("Agent deleted successfully:", result);
            setSelectedGuid(null);
            
        } catch (error) {
            console.error("Failed to delete agent:", error);
        }
    };
    const handleSetDefaultWidget = async (guid) => {
        try {
            const response = await fetch("api/deployagentwidget", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify({
                    agent_guid: guid,
                    isDefault: true
                }),
            });

            if (!response.ok) throw new Error(`Error: ${response.status}`);
            const result = await response.json();
            console.log("Widget deployed:", result);
            window.location.reload();


        } catch (err) {
            console.error("Failed to deploy widget:", err);
        }
    };

    const handleDeployWidget = async (guid) => {
        try {
            
            setOpenModal(true);
        } catch (err) {
            console.error("Failed to deploy widget:", err);
        }
    };

    return (

            <div>
                <Box sx={{ width: '100%' }}>
                    
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="robots tabs"
                    >
                        
                        <Tab tag={Link} to="/agents" value="Agents" label="Agents" />
                    </Tabs>
                </Box>

                {
                    tabValue == "Agents" &&
                    <>

                    <NewWizardContainer title="Create a new Agent" buttonTitle="Create Agent" childComponent={AgentWizardStepper}></NewWizardContainer>
                    <GenericDataTable emptyState={<AgentsEmptyStateInfo />} readyState={<AgentsReadyState />} refreshTrigger={`${confirmationOpen}-${location.state?.refresh || 0}`} rowActions={<ActionsMenu options={options} onSelect={handleOptionSelect}></ActionsMenu>} pageUrl="/agents" fetchUrl={"api/getdatabase?table_name=agents"} ovverideColumns={["name", "picture", "title", "primary_tel"]} > </GenericDataTable>
                    </>

                }
                               

               
                <ConfirmationDialog
                    open={confirmationOpen}
                    onClose={() => setConfirmationOpen(false)}
                    onConfirm={handleDelete}
                    title="Confirm Deletion"
                    message="Are you sure you want to delete this agent? This action cannot be undone."
            />
            <DeployWidgetModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                agentGuid={selectedGuid}
                token={token}
            />

            </div>

        );
    }

